module.exports = __webpack_public_path__ + "static/assets/2239fc610dc0195d46d39fd20caf312f.png";